export enum PrintFormat {
  None,
  A4,
  Ticket,
}

export const PrintFormatLabel = new Map<number, string>([
  [PrintFormat.A4, 'A4'],
  [PrintFormat.Ticket, 'Ticket'],
]);
